import list from './list'
import create from './create'
import remove from './remove'
import update from './update'
import details from './details'
import employee from './employee'
import space from './space'
import template from './template'
import csv from './assets_export'
import fetch from './fetch'
import spacesTemplate from './spaces_tag_template'

export default {
  list,
  create,
  remove,
  update,
  details,
  employee,
  space,
  template,
  spacesTemplate,
  csv,
  fetch,
}
